// extracted by mini-css-extract-plugin
export var actionButton = "_ep-t";
export var buttonContainer = "_ep-0";
export var buttonContainer2 = "_ep-1";
export var buttonSection = "_ep-2";
export var details = "_ep-3";
export var dropdownItem = "_ep-5";
export var dropdownItemsContainer = "_ep-4";
export var fileInput = "_ep-r";
export var headerButton = "_ep-6";
export var icon = "_ep-7";
export var input = "_ep-8";
export var macroListItem = "_ep-9";
export var mainContent = "_ep-a";
export var microText = "_ep-b";
export var modal = "_ep-w";
export var optionsButton = "_ep-c";
export var paperclip = "_ep-s";
export var pillContent = "_ep-d";
export var preview = "_ep-e";
export var preview2 = "_ep-f";
export var quillEditor = "_ep-q";
export var selectedMacro = "_ep-g";
export var sidebar = "_ep-h";
export var sidebarHeader = "_ep-j";
export var sidebarList = "_ep-i";
export var sidebarListItem = "_ep-k";
export var sidebarSearch = "_ep-l";
export var snoozeDurationWrapper = "_ep-v";
export var statusPillContainer = "_ep-m";
export var tagsContainer = "_ep-n";
export var unselectedMacro = "_ep-o";
export var variable = "_ep-u";
export var wrapper = "_ep-p";